import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ToolsHero from './components/ToolsHero';
import ToolsDownload from './components/ToolsDownload';
import ToolsCalculators from './components/ToolsCalculators';
import ToolsRecommend from './components/ToolsRecommend';
import ToolsCta from './components/ToolsCta';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Tools() {
  useTitle({
    title: '工具資源｜保險建築師保單健檢與計算工具',
    description: '保險建築師提供實用保險工具與資源，包含保單健檢表、保額計算器、保障規劃指南與行業報告下載。',
  });
  return (
    <main>
      <Navbar />
      <ToolsHero />
      <ToolsDownload />
      <ToolsCalculators />
      <ToolsRecommend />
      <ToolsCta />
      <PageCta />
      <Footer />
    </main>
  );
}
